import { publicApi } from '../../api';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

const NEWSLETTER_SECTION_ID = 'newsletter-signup';
const NEWSLETTER_TOAST_KEY = 'newsletter:cta-toast';

const getSubscriberData = ({ customer, user }) => {
  if (customer?.email) {
    return {
      email: customer.email,
      name: customer.name || ''
    };
  }

  if (user?.email) {
    return {
      email: user.email,
      name: user.name || ''
    };
  }

  return null;
};

const persistToast = (type, language) => {
  try {
    sessionStorage.setItem(NEWSLETTER_TOAST_KEY, JSON.stringify({ type, language, timestamp: Date.now() }));
  } catch {
    // ignore storage failures
  }
};

const goToNewsletterSection = () => {
  if (window.location.pathname === '/') {
    const section = document.getElementById(NEWSLETTER_SECTION_ID);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
  }

  window.location.href = `/#${NEWSLETTER_SECTION_ID}`;
};

export default function NewsletterCtaButton({ label, className = '', source = 'announcement_bar', style }) {
  const { customer, user } = useAuth();
  const { language } = useLanguage();

  const handleClick = async () => {
    const subscriber = getSubscriberData({ customer, user });

    if (subscriber?.email) {
      try {
        const result = await publicApi.subscribeNewsletter({ ...subscriber, source });
        persistToast(result.item?.alreadySubscribed ? 'already' : 'success', language);
      } catch {
        persistToast('error', language);
      }
    }

    goToNewsletterSection();
  };

  return (
    <button type="button" onClick={handleClick} className={className} style={style}>
      {label}
    </button>
  );
}
